/**
 * Схема распределения объёма между победителями тендера.
 */
class WinnersCategory {

  public id: number;

  public name: string;

  public value: string;

  static fromServer(data: any): WinnersCategory {
    const result = new WinnersCategory();

    result.id    = data.id;
    result.name  = data.name;
    result.value = data.value;

    return result;
  }

  toString(): string {
    return this.name;
  }
}

export default WinnersCategory;
